import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AttributesActions, AsyncActions } from './attributes.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import { Attribute } from '@emm/core/models/attribute.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';
import {withLoadables} from '@emm/core/util/ngrx.util';
import {AttributeType} from '@emm/core/models/attribute-type.model';

export const attributesFeatureKey = 'attributes';

export interface AttributesState extends EntityState<Attribute>, AsyncActionState {
    selectedTag: string | null;
    searchFilter: SearchFilter;
    attributeTypes: AttributeType[];
}

export const adapter: EntityAdapter<Attribute> = createEntityAdapter<Attribute>({
    selectId: (item: Attribute) => item.tag,
    sortComparer: null
});

export const initialState: AttributesState = adapter.getInitialState({
    selectedTag: null,
    searchFilter: null,
    attributeTypes: [],
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const attributesReducer = withLoadables<AttributesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ManagementBaseActions.initItems, ManagementBaseActions.initAttributes, () => ({
        ...initialState
    })),

    on(AttributesActions.load, (state: AttributesState) => ({
        ...state,
        selectedTag: null
    })),

    on(AttributesActions.loadGlobalAttributesSuccess, (state: AttributesState, { attributes }) =>
        adapter.setAll(attributes, state)
    ),

    on(AttributesActions.loadSuccess, (state: AttributesState, { attributes, attributeTypes }) =>
        adapter.setAll(attributes, {
            ...state,
            attributeTypes
        })
    ),

    on(AttributesActions.select, (state: AttributesState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

    on(AttributesActions.searchAttributes, (state: AttributesState, { filter }) => ({
        ...state,
        searchFilter: filter
    }))

);
